import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_question_mark.svg';
import Icon, { IconProps } from './icon';

const IconQuestionMark = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconQuestionMark;
